// src/spares-admin/components/SparesSidebar.jsx

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../services/firebase';
import {
  HomeIcon,
  UsersIcon,
  TruckIcon,
  CubeIcon,
  BanknotesIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  ArrowLeftOnRectangleIcon,
  PlusCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';

const menuItems = [
  { path: '/spares-admin/dashboard', icon: HomeIcon,     label: 'Dashboard' },
  { path: '/spares-admin/porters',   icon: UsersIcon,    label: 'Porters' },
  { path: '/spares-admin/tasks',     icon: TruckIcon,    label: 'Deliveries' },
  { path: '/spares-admin/create-task', icon: PlusCircleIcon, label: 'Create Task' },
  { path: '/spares-admin/products',  icon: CubeIcon,     label: 'Products' },
  { path: '/spares-admin/cash-deposits', icon: BanknotesIcon, label: 'Cash Deposits' },
  { path: '/spares-admin/invoices',  icon: DocumentTextIcon, label: 'Invoices' },
  { path: '/spares-admin/reports',   icon: ChartBarIcon, label: 'Reports' },
  { path: '/spares-admin/settings',  icon: Cog6ToothIcon, label: 'Settings' },
];

function SparesSidebar({ isOpen, setIsOpen }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
<aside
  className={`h-screen sticky top-0 bg-white border-r border-gray-200 transition-all duration-300 shadow-lg ${
    isOpen ? 'w-64' : 'w-20'
  }`}
>


      {/* Logo */}
      <div className="h-16 flex items-center justify-between px-4 border-b border-gray-200">
        {isOpen && (
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-red-600 to-red-700 rounded-xl flex items-center justify-center">
              <TruckIcon className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-gray-900 font-bold text-lg">Porter</h1>
              <p className="text-gray-500 text-xs">Admin Panel</p>
            </div>
          </div>
        )}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="p-2 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-900 transition-colors"
        >
          {isOpen ? (
            <ChevronLeftIcon className="w-5 h-5" />
          ) : (
            <ChevronRightIcon className="w-5 h-5" />
          )}
        </button>
      </div>

      {/* Navigation */}
      <nav className="p-4 space-y-2">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
         className={({ isActive }) =>
  `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 group ${
    isActive
      ? 'bg-red-100 text-red-800 font-semibold shadow-sm'
      : 'text-gray-800 hover:bg-gray-100 hover:text-gray-950'
  }`
}

            end={item.path === '/spares-admin/dashboard'}
          >
            {({ isActive }) => (
              <>
                <item.icon className={`w-6 h-6 flex-shrink-0 ${!isOpen && 'mx-auto'} ${isActive ? 'text-red-700' : 'text-gray-600'}`} />
                {isOpen && <span className="font-medium">{item.label}</span>}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    

      {/* Logout */}
      {/* <div className="absolute bottom-4 left-4 right-4">
        <button
          onClick={handleLogout}
          className={`flex items-center gap-3 px-3 py-3 rounded-xl text-gray-400 hover:bg-red-600/20 hover:text-red-400 transition-all duration-200 w-full ${
            !isOpen && 'justify-center'
          }`}
        >
          <ArrowLeftOnRectangleIcon className="w-6 h-6" />
          {isOpen && <span className="font-medium">Logout</span>}
        </button>
      </div> */}
    </aside>
  );
}

export default SparesSidebar;